import React from "react";
import { Box, Grid, Typography, Paper } from "@material-ui/core";
import FieldLabel from "../../../components/common/label";
import withStyles from "@material-ui/core/styles/withStyles";

const styles = (theme) => ({
  container: {
    padding: theme.spacing(2),
  },
  tableRow: {
    display: "flex",
    justifyContent: "space-between",
    padding: theme.spacing(1, 0),
    borderBottom: "1px solid #ccc",
  },
  tableCell: {
    flex: 1,
    textAlign: "left",
  },
  title: {
    textAlign: "left",
  },
});

function DepreciationSlab(props) {
  const { classes } = props;

  const slabData = [
    {
      age: "Up to 90 days from the date of purchase of the Registered Device",
      depreciation: "20% of the Invoice Value",
    },
    {
      age: "Between 91 days to 180 days from date of purchase of the Registered Device",
      depreciation: "30% of the Invoice Value",
    },
    {
      age: "Between 181 days to 365 days from date of purchase of the Registered Device",
      depreciation: "50% of the Invoice Value",
    },
  ];

  return (
    <Paper className={classes.container}>
      <Typography  variant="h5" className={classes.title}>
        Depreciation Slab
      </Typography>
      <Typography className={classes.title}>
        The standard depreciation matrix applicable for registered device under this Plan is as below:
      </Typography>
      <Box>
        {slabData.map((slab, index) => (
          <Box key={index} className={classes.tableRow}>
            <Typography className={classes.tableCell}>{slab.age}</Typography>
            <Typography className={classes.tableCell} style={{ textAlign: "right" }}>
              {slab.depreciation}
            </Typography>
          </Box>
        ))}
      </Box>
    </Paper>
  );
}

export default withStyles(styles)(DepreciationSlab);
